export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-3-07.4204cd98.jpg";